// extracted by mini-css-extract-plugin
export var auto = "_38-1";
export var spinner = "_38-0";